import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/modules/shared.module';
import { HistorialCambioDialogComponent } from '@views/historial-cambio/historial-cambio-dialog.component';
import { ChartsModule } from 'ng2-charts';


@NgModule({
  declarations: [
    HistorialCambioDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ChartsModule,
  ],
  exports:[
    HistorialCambioDialogComponent
    ]

})
export class HistorialCambioModule { }
